<template>
  <div>
    <component v-bind:is="currentComponent"></component>
  </div>
</template>

<script>
import { getHomeConfig } from '@/api/settings'
import monitorHome from './home'
import reportHome from './home-reports'
import worksheetHome from '@/view/single-page/home/home-ws'

export default {
  name: 'main',
  data () {
    return {
      currentComponent: ''
    }
  },
  created: function () {
    this.getHomeModuleList()
  },
  methods: {
    getHomeModuleList () {
      getHomeConfig().then(res => {
        let result = res.data
        if (result.homePage === 'monitor') {
          this.currentComponent = monitorHome
        } else if (result.homePage === 'reports') {
          this.currentComponent = reportHome
        } else {
          this.currentComponent = worksheetHome
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
